import { render, staticRenderFns } from "./untrust_projects.vue?vue&type=template&id=3a45b583&"
import script from "./untrust_projects.vue?vue&type=script&lang=js&"
export * from "./untrust_projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a45b583')) {
      api.createRecord('3a45b583', component.options)
    } else {
      api.reload('3a45b583', component.options)
    }
    module.hot.accept("./untrust_projects.vue?vue&type=template&id=3a45b583&", function () {
      api.rerender('3a45b583', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/untrust_projects.vue"
export default component.exports